import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { LogOut, Moon, Sun, PlusCircle, LayoutList } from "lucide-react";
import { cn } from "@/lib/utils";
import { NotificationBell } from "@/components/NotificationBell";

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const { dark, toggle } = useTheme();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate(`/${user?.company?.slug || ""}`);
  };

  const linkCls = ({ isActive }) => cn(
    "flex items-center gap-2 rounded-sm px-3 py-2 text-sm transition-colors duration-200",
    isActive ? "bg-primary/10 text-primary font-semibold" : "text-foreground/80 hover:bg-accent hover:text-foreground"
  );

  return (
    <div className="min-h-dvh bg-background" data-testid="portal-layout">
      <header className="sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3">
          <div className="flex items-center gap-3 min-w-0">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-sm bg-primary text-white font-heading font-bold">S</div>
            <div className="min-w-0">
              <div className="truncate font-heading font-semibold">{user?.company?.name}</div>
              <div className="text-xs text-muted-foreground">Portail client — Suivio360</div>
            </div>
          </div>
          <nav className="flex items-center gap-1">
            <NavLink to="/portal" end data-testid="portal-nav-tickets" className={linkCls}>
              <LayoutList className="h-4 w-4" /> <span className="hidden sm:inline">Mes demandes</span>
            </NavLink>
            <NavLink to="/portal/nouvelle-demande" data-testid="portal-nav-new-ticket" className={linkCls}>
              <PlusCircle className="h-4 w-4" /> <span className="hidden sm:inline">Nouvelle demande</span>
            </NavLink>
            <NotificationBell />
            <button data-testid="theme-toggle-button" onClick={toggle} className="rounded-sm border border-border p-2 hover:bg-accent transition-colors duration-200">
              {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
            </button>
            <button data-testid="logout-button" onClick={doLogout} className="rounded-sm border border-border p-2 hover:bg-primary hover:text-white transition-colors duration-200" title="Se déconnecter">
              <LogOut className="h-4 w-4" />
            </button>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-5xl overflow-x-hidden p-4 pb-24 sm:p-8">
        <Outlet />
      </main>
    </div>
  );
}
